export default {
  namespaced: true,
  state: {
    firstStart: false,
    codeConfirm: false,
    rightMenu: false,
    singup: false,
    singin: false,
    fastbuy: false,
    feedback: false,
    feedbackOwner: false,
    callBackForm: false,
    notSingIn: false,
    changePassword: false,
    passwordrecovery: false,
    shoppingCart: false,
    confirmBlock: {
      status: false,
      error: false,
      title: '',
      text: '',
    },
    fastbuymessage: '',
    fastbuymessageId: null,
    userMenu: false,
    leftMenu: true,
    mobile: null,
    leftMenuVisible: false,
    breadcrumbs: '/',
    auth: false,
    signUpInfo: {},
    token: null,
    recoveryPasswordPhone: '',
    confirmCodeType: '',
    newPasswordBlock: false,
    updateProfileCallback: null,
  },
  getters: {},
  mutations: {
    setLeftMenuVisible: function (state, value) {
      state.leftMenuVisible = value;
    },
    toggleRightMenu: function (state) {
      if (state.rightMenu) {
        state.singin = false;
        state.fastbuy = false;
        state.singup = false;
        state.passwordrecovery = false;
        state.feedback = false;
        state.feedbackOwner = false;
        state.confirmBlock.status = false;
        state.changePassword = false;
        state.codeConfirm = false;
        state.notSingIn = false;
        state.firstStart = false;
        state.newPasswordBlock = false;
        state.callBackForm = false;
      }

      if (state.mobile && state.leftMenu) {
        state.leftMenu = false;
      } else {
        document.querySelector('body').classList.toggle('fixed');
      }
      state.rightMenu = !state.rightMenu;
    },
    toggleShoppingCart: function (state) {
      if (state.mobile && state.leftMenu) {
        state.leftMenu = false;
        state.shoppingCart = !state.shoppingCart;
      } else {
        state.shoppingCart = !state.shoppingCart;
        document.querySelector('body').classList.toggle('fixed');
      }
    },
    toogleFirstStart: function (state) {
      state.firstStart = !state.firstStart;
    },
    toogleCodeConfirm: function (state) {
      state.codeConfirm = !state.codeConfirm;
    },
    toogleSingup: function (state) {
      state.singup = !state.singup;
    },
    toogleSingin: function (state) {
      state.singin = !state.singin;
    },
    toggleFastbuy: function (state) {
      state.fastbuy = !state.fastbuy;
    },
    toogleCallBackForm: function (state) {
      state.callBackForm = !state.callBackForm;
    },
    toggleNotSingIn: function (state) {
      state.notSingIn = !state.notSingIn;
    },
    toogleAuth: function (state) {
      state.auth = !state.auth;
    },
    setAuthOn: function (state) {
      state.auth = true;
    },
    setAuthOff: function (state) {
      state.auth = false;
    },
    toogleChangePassword: function (state) {
      state.changePassword = !state.changePassword;
    },
    togglePasswordrecovery: function (state) {
      state.passwordrecovery = !state.passwordrecovery;
    },
    setFastBuymessage: function (state, data) {
      state.fastbuymessage = data.value;
      if (data.id) {
        state.fastbuymessageId = data.id;
      }
    },
    toogleFeedack: function (state) {
      state.feedback = !state.feedback;
    },
    toogleFeedackOwner: function (state) {
      state.feedbackOwner = !state.feedbackOwner;
    },
    toogleConfirmBlock: function (state, { title, text, error }) {
      state.confirmBlock.title = title ? title : '';
      state.confirmBlock.text = text ? text : '';
      state.confirmBlock.error = error ? error : false;
      state.confirmBlock.status = !state.confirmBlock.status;
    },
    setCookies: function (state) {
      state.cookies = false;
    },
    toogleUserMenu: function (state) {
      state.userMenu = !state.userMenu;
    },
    openleftMenu: function (state) {
      state.leftMenu = true;
      if (state.mobile) {
        document.querySelector('body').classList.add('fixed');
      }
    },
    closeleftMenu: function (state) {
      state.leftMenu = false;
      if (state.mobile) {
        document.querySelector('body').classList.remove('fixed');
      }
    },
    closeleftMenuMobile: function (state) {
      state.leftMenu = false;
    },
    setMobile: function (state, value) {
      state.mobile = value;
    },
    setBreadcrumbs: function (state, value) {
      state.breadcrumbs = value;
    },
    setSignUpInfo: function (state, obj) {
      state.signUpInfo = obj;
    },
    setToken: function (state, token) {
      state.token = token;
    },
    setRecoveryPasswordPhone: function (state, phone) {
      state.recoveryPasswordPhone = phone;
    },
    setConfirmCodeType: function (state, data) {
      state.confirmCodeType = data;
    },
    toggleNewPasswordBlock: function (state) {
      state.newPasswordBlock = !state.newPasswordBlock;
    },
    setUpdateProfileCallback: function (state, callback) {
      state.updateProfileCallback = callback;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/params.js